import { supabase } from '@/integrations/supabase/client';

/**
 * Hook that provides the Supabase client.
 * Returns the native Supabase client with built-in session management.
 * The client automatically includes auth headers from the persisted session.
 */
export const useSupabase = () => {
  return supabase;
};
